import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Toaster as Sonner } from "sonner";
import { useCookieConsent } from "../../modules/components/CookieConsent";

const LOGIN_PATHS = ["/login", "/admin"];

function useIsMobile() {
    const [isMobile, setIsMobile] = useState(() => window.innerWidth < 1024);
    useEffect(() => {
        const mq = window.matchMedia("(max-width: 1023px)");
        const handler = (e) => setIsMobile(e.matches);
        mq.addEventListener("change", handler);
        return () => mq.removeEventListener("change", handler);
    }, []);
    return isMobile;
}

export function Toaster(props) {
    const location = useLocation();
    const isMobile = useIsMobile();
    const { hasConsented } = useCookieConsent();
    const isLoginPage = LOGIN_PATHS.some((p) => location.pathname.startsWith(p));

    const position = isMobile ? "bottom-center" : "top-right";
    const offset = isMobile && !hasConsented ? 300 : undefined;

    return (
        <Sonner
            richColors
            closeButton
            position={position}
            offset={offset}
            className={isLoginPage ? "toaster-login" : "toaster-app"}
            toastOptions={{
                style: {
                    fontFamily: "inherit",
                },
            }}
            {...props}
        />
    );
}
